/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TeamChangeLog } from './teamChangeLog';


export interface TeamChangeLogResultResponse { 
    /**
     * the total number of results
     */
    count: number;
    result: Array<TeamChangeLog>;
}

